import { render, staticRenderFns } from "./bankStatementExportFull.vue?vue&type=template&id=135b0842&lang=pug"
import script from "./bankStatementExportFull.vue?vue&type=script&lang=js"
export * from "./bankStatementExportFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports